import { supabaseExtended } from "@/integrations/supabase/extendedClient";

interface MetricsDataPoint {
  month: string;
  actualTransactions: number;
  projectedTransactions: number;
  actualUsers: number;
  projectedUsers: number;
  actualRevenue: number;
  projectedRevenue: number;
}


// Mock data until real API endpoint is available
const mockData: MetricsDataPoint[] = [
  { month: 'Jan', actualTransactions: 85, projectedTransactions: 90, actualUsers: 20, projectedUsers: 25, actualRevenue: 180, projectedRevenue: 200 },
  { month: 'Feb', actualTransactions: 120, projectedTransactions: 110, actualUsers: 28, projectedUsers: 30, actualRevenue: 240, projectedRevenue: 250 },
  { month: 'Mar', actualTransactions: 160, projectedTransactions: 130, actualUsers: 35, projectedUsers: 35, actualRevenue: 320, projectedRevenue: 300 },
  { month: 'Apr', actualTransactions: 190, projectedTransactions: 150, actualUsers: 42, projectedUsers: 40, actualRevenue: 380, projectedRevenue: 350 },
];

export const fetchPlatformMetrics = async (): Promise<MetricsDataPoint[]> => {
  const { data, error } = await (supabaseExtended as any)
    .from("web3_activity")
    .select("amount,created_at,action_type")
    .order("created_at", { ascending: true })
    .limit(5000);
  if (error || !data?.length) return mockData;

  const grouped = new Map<string, MetricsDataPoint>();
  for (const activity of data as any[]) {
    const date = new Date(activity.created_at);
    const month = date.toLocaleString("en-US", { month: "short" });
    const current = grouped.get(month) || { month, actualTransactions: 0, projectedTransactions: 0, actualUsers: 0, projectedUsers: 0, actualRevenue: 0, projectedRevenue: 0 };
    current.actualTransactions += 1;
    current.actualRevenue += Number(activity.amount || 0);
    grouped.set(month, current);
  }
  return [...grouped.values()].map((item) => ({ ...item, actualUsers: item.actualTransactions, projectedTransactions: item.actualTransactions, projectedUsers: item.actualUsers, projectedRevenue: item.actualRevenue }));
};
